const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_ng_component_scss") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.73,6.67,15.85,2V30L4.77,23.88Z",
    style: {
      fill: "#de3641"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85,2,29.27,6.59,27.08,23.8,15.85,30Z",
    style: {
      fill: "#b13138"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85,5.14l8.53,18.23H21.47l-1.82-4.16h-3.8V16.73h2.77L15.85,11l-2.33,5.73h2.33v2.48H12.38l-1.63,4.16H7.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.65,15.29a7.35,7.35,0,1,1-7.35,7.35h0A7.35,7.35,0,0,1,22.65,15.29Z",
    style: {
      fill: "#c69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.26,18.44c-.33-1.31-2.5-1.73-4.55-1a10.3,10.3,0,0,0-3.49,2c-1.13,1.06-1.31,2-1.23,2.36.26,1.36,2.12,2.24,2.88,2.9h0c-.22.11-1.87.95-2.26,1.8a1.19,1.19,0,0,0,.38,1.63,2.31,2.31,0,0,0,2.49-1,2.53,2.53,0,0,0,.25-2.25,3,3,0,0,1,1.13-.06c1.29.15,1.54,1,1.49,1.29a.85.85,0,0,1-.41.58c-.09.06-.12.08-.11.12s.05.06.13,0a1,1,0,0,0,.7-.9,1.82,1.82,0,0,0-1.966-1.662q-.052,0-.1.012a3.54,3.54,0,0,0-1.15.16l-.06-.06c-.83-.88-2.36-1.51-2.3-2.7,0-.43.17-1.57,2.94-3,2.27-1.13,4.09-.82,4.4-.13.45,1-1,2.82-3.33,3.08a1.77,1.77,0,0,1-1.49-.38c-.12-.14-.14-.14-.19-.12s0,.16,0,.23a1.4,1.4,0,0,0,.85.67,4.51,4.51,0,0,0,2.74-.2C26.47,21.26,27.59,19.72,27.26,18.44ZM21.18,25.1a1.88,1.88,0,0,1,0,1.1v.22a2.05,2.05,0,0,1-.34.5,1.251,1.251,0,0,1-1.28.49c-.28-.15-.14-.82.36-1.34a5,5,0,0,1,1.3-.93h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScss);
export default __webpack_public_path__ + "static/media/scss.5f9e357a63bd7bbbf5f772308fa6424e.svg";
export { ForwardRef as ReactComponent };